module.exports = __webpack_public_path__ + "static/media/logo_babylone.f8661531.png";